export { default } from './FormControlLabel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormControlLabel/index.js
// module id = 327
// module chunks = 0